import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export type SiteAlertLevel = 'info' | 'warning' | 'danger';

export interface SiteAlertBannerResponse {
  enabled: boolean;
  level: SiteAlertLevel;
  message: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class SiteAlertsService {
  private baseUrl = `${environment.url_servicios}/v2/site-alerts`;
  private http = inject(HttpClient);

  getLoginWarning(): Observable<SiteAlertBannerResponse> {
    return this.http.get<SiteAlertBannerResponse>(`${this.baseUrl}/login-warning`);
  }
}
